export default __webpack_public_path__ + "static/media/agm-logo-small.02e09fd5.png";